import { Input } from '@/components/ui/input';

export interface InputProps {
  value?: string,
  onValueChange?: (value: string, extraOpts?: Record<string, unknown>) => void,
  placeholder?: string,
  className?: string,
  isValid?: boolean;
  disabled?: boolean;
}

export const InputComponent = ({ value, onValueChange, placeholder, className, isValid = true, ...restProps }: InputProps) => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onValueChange?.(e.target.value)
  }

  return <Input value={value} onChange={onChange} placeholder={placeholder} className={className} isValid={isValid} {...restProps} />
}
